const defaultColDef = {
  sortable: true,
  filter: true,
  resizable: true,
};

export const gridOptions = {
  suppressMenuHide: false,
  defaultColDef,
  enableCharts: true,
  animateRows: true,
  enableRangeSelection: true,
  rowDragManaged: true,
  headerHeight: 30,
  rowHeight: 35,
  suppressCsvExport: true,
  suppressExcelExport: true,
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
  },
  pagination: true,
  rowMultiSelectWithClick: true,
  // suppressClickEdit: true,
  // enableCellChangeFlash: true,
  // suppressCellFlash: true,
};
